const Footer = () => {
  let currentYear = new Date().getFullYear();

  return (
    <div>
      <footer className="main-footer" style={{zIndex: "0"}}>
        <div className="float-right d-none d-sm-block">
          <b>Version</b> 5.0.1
        </div>
        <strong>
          Droits d'auteur © {currentYear} <a href="https://iware.info/">IWARE</a>.
        </strong>{" "}
        Tous les droits sont réservés.
      </footer>
    </div>
  );
};
export default Footer;
